import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Button } from '@rogers/cdk/button';
import { AccountDetail, fetchAccountDetailSuccess } from '@rogers/self-serve-common/account';
import { tap } from 'rxjs/operators';
import { PORT_IN_ROUTE } from '../app.constant';
import { AlertFacadeService } from '@rogers/self-serve-common/alert';

@Injectable()
export class PortInAlertsEffects {
  private readonly actions$ = inject(Actions);
  private readonly alertFacadeService = inject(AlertFacadeService);

  loadPortInAlerts$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchAccountDetailSuccess),
        tap(({ accountDetail }) => {
          this.addPortInAlerts(accountDetail);
        }),
      ),
    { dispatch: false },
  );

  private getDaysDifference(activationDate, duration) {
    const activationDateMS = new Date(activationDate).getTime();
    const addDaysMS = new Date(activationDateMS + duration * 24 * 60 * 60 * 1000).getTime();
    const currentDateMS = new Date().getTime();
    return (addDaysMS - currentDateMS) / (1000 * 3600 * 24);
  }

  private addPortInAlerts(accountDetail: AccountDetail) {
    if (!accountDetail.subscriptions) {
      return;
    }
    accountDetail.subscriptions.forEach(subscription => {
      const activationDate = subscription.activationDate;
      const difference = this.getDaysDifference(activationDate, 15);

      if (difference >= 0) {
        const portInCta: Button = {
          copy: 'port-in-alert.banner-cta',
          val: PORT_IN_ROUTE,
          alt: 'port-in-alert.banner-cta-alt',
        };
        const alertBody = 'port-in-alert.banner-details';
        this.alertFacadeService.upsertAlert(
          this.getAlertObject(
            `${subscription.subNumber}-port-in-banner`,
            'port_in_alert',
            'subscriber',
            'info',
            alertBody,
            'info-filled',
            'port-in-alert.banner-icon-alt',
            'port-in-alert.banner-close-alt',
            [portInCta],
            true,
            'port-in-alert.banner-header',
          ),
        );
      }
    });
  }

  private getAlertObject(
    key,
    uniqueAlertId,
    type,
    alertVariant,
    alertBody,
    alertIcon,
    alertIconCaption,
    alertCloseLabel,
    alertCta,
    showCloseButton = true,
    title = '',
    order = 999,
  ) {
    return {
      key,
      uniqueAlertId,
      type,
      order,
      alertData: {
        showCloseButton,
        variant: alertVariant,
        copy: {
          iconCaption: alertIconCaption,
          body: alertBody,
          closeLabel: alertCloseLabel,
          title,
        },
        cta: alertCta,
      },
      iconName: alertIcon,
    };
  }
}
